// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-info{background-color:#f6faff!important}.text-info{color:#3f96c9!important}.featuredBuyersSearchingMap .map-background{background-color:var(--tif-theme-primary-color)}", ""]);
// Exports
exports.locals = {
	"primary": "var(--tif-theme-primary-color)",
	"primary25shade": "hsl(var(--tif-theme-primary-color-h),var(--tif-theme-primary-color-s),calc(var(--tif-theme-primary-color-l)*0.75))",
	"primary25tint": "hsl(var(--tif-theme-primary-color-h),var(--tif-theme-primary-color-s),calc(var(--tif-theme-primary-color-l)*1.25))",
	"ltgray": "#e9edf0",
	"lightgraytext": "#b7c1c5",
	"background_gray": "#e1e2e3",
	"pdf_page_bg_gray": "#f8f7f6",
	"smalltextgray": "#7e848a"
};
module.exports = exports;
